import React from 'react';
import { MagicWandIcon } from './icons/MagicWandIcon';

/**
 * Session Not Found Screen
 * Displayed when user accesses the app directly without authentication
 */
export const SessionNotFound = () => {
    const handleGoToLoopAI = () => {
        window.location.href = 'https://app.loopai.in';
    };

    return (
        <div className="min-h-screen bg-[#0a0a12] flex flex-col items-center justify-center px-4">
            {/* Logo */}
            <div className="flex items-center gap-3 mb-8">
                <div className="w-12 h-12 bg-purple-600 rounded-xl flex items-center justify-center">
                    <MagicWandIcon className="w-7 h-7 text-white" />
                </div>
                <h1 className="text-3xl font-bold text-white tracking-tight">LoopAi-adstudio</h1>
            </div>

            {/* Session Not Found Message */}
            <div className="text-center max-w-md">
                <h2 className="text-xl font-semibold text-purple-400 mb-4" data-testid="session-not-found-title">
                    Session not found
                </h2>
                <p className="text-gray-400 mb-8 leading-relaxed">
                    Please log into your LoopAI account first, then navigate back to LoopAi-adstudio.
                </p>

                {/* Go to LoopAI Button */}
                <button
                    onClick={handleGoToLoopAI}
                    className="inline-flex items-center gap-2 px-6 py-3 bg-purple-600 hover:bg-purple-700 text-white font-semibold rounded-lg transition-colors"
                    data-testid="go-to-loopai-btn"
                >
                    Go to LoopAI
                    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                    </svg>
                </button>
            </div>

            {/* Footer */}
            <p className="absolute bottom-8 text-gray-600 text-sm">
                Powered by LoopAI
            </p>
        </div>
    );
};
